import { SchemaStore } from '@sensenet/default-content-types';
/**
 * The default Sense/Net OData Service token (odata.svc)
 */
export const DEFAULT_SERVICE_TOKEN = 'odata.svc';

/**
 * Interface for sensenet Repository configuration
 */

/**
 * Repository configuration with defaults that are not undefined.
 * token, defaultExpand properties doesn't have a default value. They are undefined.
 */

export const defaultRepositoryConfiguration = {
  chunkSize: 1000000,
  defaultEnableAutofilters: false,
  defaultEnableLifespanfilter: false,
  defaultInlineCount: 'allpages',
  defaultMetadata: 'no',
  defaultSelect: ['DisplayName', 'Description', 'Icon'],
  defaultTop: 10000,
  oDataToken: DEFAULT_SERVICE_TOKEN,
  repositoryUrl: '',
  requiredSelect: ['Id', 'Path', 'Name', 'Type'],
  schemas: SchemaStore,
  identityServerUrl: ''
};
//# sourceMappingURL=RepositoryConfiguration.js.map